// @Vendors
import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

// @Template
import LoginTemplate from '../Templates/LoginTemplate';

const LoginRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={(props) => (
      <LoginTemplate>
        <Component {...props} />
      </LoginTemplate>
    )} />
  )
};

const mapStateToProps = state => ({});

const actions = {};

export default connect(
  mapStateToProps,
  actions
)(LoginRoute);


// WEBPACK FOOTER //
// ./src/pages/App/Routes/LoginRoute.js